import { makeStyles } from '@material-ui/core';

const styles = makeStyles(() => ({
  rootButton: {
    display: 'flex',
    justifyContent: 'center',
    width: '152px',
    height: '32px',
    borderRadius: '4px',
    border: ' 1px solid #0F83AD',
    borderColor: '#0F83AD',
  },
  title: {
    height: '24px',
    width: '64px',
    fontFamily: ' Nunito Sans',
    fontSize: '17px',
    color: '#0F83AD',
  },
}));
export default styles;
